import { useEffect } from "react";

function useServiceWorkerRegistration() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .catch((err) => console.error("SW registration failed:", err));
    }
  }, []);
}

export default useServiceWorkerRegistration;
